var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"language-switcher",on:{"click":function($event){return _vm.$emit('change-language', _vm.lang === 'ptbr' ? 'en' : 'ptbr')}}},[_vm._v(" "+_vm._s(_vm.lang === 'ptbr' ? 'EN' : 'PT-BR')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }